import ActionChip from './ActionChip';

export type { ActionChipItem, ActionChipProps } from './ActionChip';
export default ActionChip;